import {apiRequest} from "../helpers/utils";

export const botRulesServices = {
    create,
    update,
    find,
    fetch,
    remove,
};

function fetch() {
    return apiRequest("get", "v1/tenant-settings/bot-rules", {}, {});
}

function create({formData}) {
    return apiRequest("post", "v1/tenant-settings/bot-rules", formData);
}

function update({id, formData}) {
    return apiRequest("put", "v1/tenant-settings/bot-rules/" + parseInt(id), formData);
}

function find({id}) {
    return apiRequest("get", "v1/tenant-settings/bot-rules/" + parseInt(id));
}

function remove({id}) {
    return apiRequest("delete", "v1/tenant-settings/bot-rules/" + parseInt(id), {});
}